export const DynamicHorizontalTable = ({
  data,
  keysToShow = null // optional
}) => {
  
  try {
    // Basic validation
    if (!data || typeof data !== "object" || Array.isArray(data)) {
     
      return (
        <div className="text-sm text-gray-500">
          
          No valid data available
        </div>
      );
    }

    

    // Determine keys to render
    const allKeys = Object.keys(data);
    const keys =
      Array.isArray(keysToShow) && keysToShow.length > 0
        ? keysToShow.filter((key) => key in data) // ignore invalid keys
        : allKeys;

    // Handle empty object or no valid keys
    if (keys.length === 0) {
      return (
        <div className="text-sm text-gray-500">
          No data to display
        </div>
      );
    }

    return (
      <div className="overflow-x-auto">
        
        <table className="table-auto border-collapse w-full">
          <thead className="bg-gray-100">
            <tr>
              {keys.map((key) => (
                <th
                  key={key}
                  className="border px-3 py-2 capitalize whitespace-nowrap"
                >
                  {key.replaceAll("_", " ")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {keys.map((key) => (
                <td
                  key={key}
                  className="border px-3 py-2 whitespace-nowrap"
                >
                  {data[key] === null || data[key] === undefined
                    ? "-"
                    : typeof data[key] === "object"
                    ? JSON.stringify(data[key])
                    : String(data[key])}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    );
  } catch (error) {
    console.error("DynamicHorizontalTable error:", error);

    return (
      <div className="text-sm text-red-500">
        Something went wrong while rendering the table.
      </div>
    );
  }
};



export const DynamicHorizontalTable2 = ({
  data,
  keysToShow = null
}) => {
  try {
    if (!data) {
      return <div className="text-sm text-gray-500">No data available</div>;
    }

    // 🔹 Helper to render values
    const renderValue = (value) => {
      if (value === null || value === undefined) return "-";

      if (Array.isArray(value)) {
        if (value.length === 0) return "-";

        // array of objects
        if (typeof value[0] === "object") {
          return (
            <ul className="list-disc pl-4 space-y-1">
              {value.map((item, i) => (
                <li key={i} className="text-xs">
                  {JSON.stringify(item)}
                </li>
              ))}
            </ul>
          );
        }

        // array of primitives
        return value.join(", ");
      }

      if (typeof value === "object") {
        return JSON.stringify(value);
      }

      return String(value);
    };

    // 🟢 CASE 1: data is an ARRAY
    if (Array.isArray(data)) {
      if (data.length === 0) {
        return <div className="text-sm text-gray-500">No data to display</div>;
      }

      const keys =
        Array.isArray(keysToShow) && keysToShow.length
          ? keysToShow
          : Object.keys(data[0]);

      return (
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full">
            <thead className="bg-gray-100">
              <tr>
                {keys.map((key) => (
                  <th
                    key={key}
                    className="border px-3 py-2 capitalize whitespace-nowrap"
                  >
                    {key.replaceAll("_", " ")}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {keys.map((key) => (
                    <td
                      key={key}
                      className="border px-3 py-2 whitespace-nowrap align-top"
                    >
                      {renderValue(row[key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    // 🟢 CASE 2: data is an OBJECT
    const keys =
      Array.isArray(keysToShow) && keysToShow.length
        ? keysToShow.filter((key) => key in data)
        : Object.keys(data);

    if (keys.length === 0) {
      return <div className="text-sm text-gray-500">No data to display</div>;
    }

    return (
      <div className="overflow-x-auto">
        <table className="table-auto border-collapse w-full">
          <thead className="bg-gray-100">
            <tr>
              {keys.map((key) => (
                <th
                  key={key}
                  className="border px-3 py-2 capitalize whitespace-nowrap"
                >
                  {key.replaceAll("_", " ")}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {keys.map((key) => (
                <td
                  key={key}
                  className="border px-3 py-2 whitespace-nowrap align-top"
                >
                  {renderValue(data[key])}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    );
  } catch (error) {
    console.error("DynamicHorizontalTable error:", error);
    return (
      <div className="text-sm text-red-500">
        Something went wrong while rendering the table.
      </div>
    );
  }
};

